import React, { useLayoutEffect, useState } from "react";
import {
  InboxOutlined,
  // EditOutlined,
  // DeleteOutlined,
  RedoOutlined,
  FolderOpenOutlined,
  RollbackOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import {
  Modal,
  Tabs,
  Upload,
  Input,
  List,
  Spin,
  Card,
  Col,
  Row,
  Divider,
} from "antd";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import {
  IMAGE_BASE_URL,
  FILE_UPLOAD,
  FOLDERS,
  FILES_BY_FOLDER,
} from "../../constants/api";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { Button, Form, Space } from "antd";
import folder from "../../assets/image/folder-2.webp";
const { Dragger } = Upload;
const { Meta } = Card;

const ImageSelect = ({ isOpen, onClose, onOk, fromMager }) => {
  const [uploadedFileList, setUploadedFilesList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [folderList, setFolderList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [form] = Form.useForm();
  const { Search } = Input;

  const handleUpload = async (values) => {
    try {
      setLoading(true);
      const data = new FormData();
      data.append("folder", values.folder);
      Array.from(fileList).forEach((element) => {
        data.append("files[]", element);
      });
      data.append("tag", values.tag);

      const successFn = function (data) {
        console.log("File to response=> " + data.status, data.message);
        if (data.status === true) {
          setLoading(false);
          form.resetFields();
          setFileList([]);
          getFileList(values.folder);
          displayMessage(SUCCESS_MESSAGE, data.message);
        } else {
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
      };
      const errorFn = function () {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
      };
      postAPI(FILE_UPLOAD, data, successFn, errorFn);
    } catch (error) {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, error.message);
    }
  };

  const props = {
    multiple: true,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      const isAllowedType = allowedTypes.includes(file.type);

      if (!isAllowedType) {
        displayMessage(
          ERROR_MSG_TYPE,
          `${file.name} is not a valid image file (PNG, JPEG, JPG only)`
        );
      } else {
        setFileList([...fileList, file]);
      }

      return isAllowedType || Upload.LIST_IGNORE;
    },
    fileList,
  };

  const getFolderList = () => {
    setLoading(true);

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        setFolderList(data.data);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    getAPI(FOLDERS, successFn, errorFn);
  };

  const onImageSelect = (item) => {
    if (isSelected(item)) {
      setSelected(
        selected.filter((selectedItem) => selectedItem.id !== item.id)
      );
    } else {
      setSelected([...selected, item]);
    }
  };
  const isSelected = (item) => {
    return selected.some((selectedItem) => selectedItem.id === item.id);
  };

  const handleOk = () => {
    console.log("selected=> ", selected);
    onOk(selected);

    onClose();
  };

  const onChange = (key) => {
    console.log(key);
  };

  const getFileList = (folderName) => {
    setLoading(true);
    const data = new FormData();
    data.append("folder", folderName);

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        setUploadedFilesList(data.data);
      } else {
        setUploadedFilesList([]);
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setUploadedFilesList([]);
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(FILES_BY_FOLDER, data, successFn, errorFn);
  };

  useLayoutEffect(() => {
    getFolderList();
  }, []);

  return (
    <Modal visible={isOpen} onCancel={onClose} onOk={handleOk} width={1000}>
      <Tabs centered defaultActiveKey="1" onChange={onChange}>
        <Tabs.TabPane tab="FILES" key="1">
          <Spin spinning={loading}>
            <Card
              bordered={false}
              title={
                <Space>
                  Selected : {selected.length}
                  {<CloseCircleOutlined onClick={(e) => setSelected([])} />}
                </Space>
              }
              extra={
                <Space>
                  <Search
                    style={{ paddingTop: 10, paddingBottom: 10 }}
                    placeholder="input search text"
                    enterButton
                  />
                  {uploadedFileList.length === 0 ? (
                    <Button
                      type="primary"
                      onClick={getFolderList}
                      loading={loading}
                    >
                      {loading ? "Reloading" : <RedoOutlined />}
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      onClick={(e) => setUploadedFilesList([])}
                    >
                      <RollbackOutlined />
                    </Button>
                  )}
                </Space>
              }
            >
              {uploadedFileList.length === 0 ? (
                <List
                  grid={{
                    gutter: 16,
                    column: 6,
                  }}
                  dataSource={folderList}
                  renderItem={(item) => (
                    <Card
                      style={{
                        backgroundColor: "white",
                        padding: "5px",
                        margin: "2px",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                      key={item}
                      onClick={(e) => getFileList(item.folder)}
                      cover={
                        <div style={{ position: "relative" }}>
                          <img
                            alt="files"
                            src={folder}
                            style={{ width: "100%" }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "55%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              color: "white",
                              fontSize: "25px",
                              fontWeight: "bold",
                            }}
                          >
                            {item.count}
                          </div>
                        </div>
                      }
                    >
                      <Meta title={item.folder} />
                    </Card>
                  )}
                />
              ) : null}
              {uploadedFileList.length > 0 ? (
                <List
                  grid={{
                    gutter: 16,
                    column: 4,
                  }}
                  dataSource={uploadedFileList}
                  renderItem={(item) => (
                    <Card
                      style={{
                        backgroundColor: isSelected(item) ? "#f58922" : "white",
                        padding: "5px",
                        margin: "2px",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                      key={item.id}
                      onClick={() => onImageSelect(item)}
                      cover={
                        <img
                          style={{
                            width: "100%",
                            //   height: "30vh",
                            objectFit: "cover",
                          }}
                          alt="files"
                          src={IMAGE_BASE_URL + item.filePath}
                        />
                      }
                      actions={
                        fromMager
                          ? [
                              // <EditOutlined key="edit" />,
                              // <DeleteOutlined
                              //   onClick={(e) =>
                              //     exDestroy(item.filePath, item.id)
                              //   }
                              //   key="delete"
                              // />,
                            ]
                          : []
                      }
                    >
                      <Meta
                        title={item.tag}
                        description={item.folder + "/" + item.filePath}
                      />
                    </Card>
                  )}
                />
              ) : null}
            </Card>
          </Spin>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Upload New" key="2">
          <Spin spinning={loading}>
            <Form
              form={form}
              name="validate_other"
              onFinish={handleUpload}
              layout="vertical"
            >
              <Row>
                <Col span={11} offset={1} center>
                  <Dragger {...props}>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload
                    </p>
                    <p className="ant-upload-hint">
                      Only (PNG, JPEG, JPG) formate supported
                    </p>
                  </Dragger>
                </Col>
                <Col span={11} offset={1} center>
                  <center>
                    <Form.Item
                      name="tag"
                      label="Tag"
                      rules={[
                        {
                          required: true,
                          message: "Please input tag!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="folder"
                      label="Folder"
                      rules={[
                        {
                          required: true,
                          message: "Please input folder!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    {folderList.length > 0 ? (
                      <div>
                        <Divider orientation="left">Folder's</Divider>
                        <Space wrap="wrap" gap="small">
                          {folderList.map((item) => (
                            <Button
                              style={{
                                maxWidth: "150px",
                                margin: "2px",
                              }}
                              onClick={(e) =>
                                form.setFieldValue("folder", item.folder)
                              }
                              type="dashed"
                              icon={<FolderOpenOutlined />}
                            >
                              {item.folder}
                            </Button>
                          ))}
                        </Space>
                      </div>
                    ) : null}
                    <Form.Item>
                      <Space>
                        <Button
                          type="primary"
                          htmlType="submit"
                          disabled={fileList.length === 0}
                          loading={loading}
                          style={{
                            marginTop: 16,
                          }}
                        >
                          {loading ? "Uploading" : "Start Upload"}
                        </Button>

                        <Button
                          htmlType="reset"
                          style={{
                            marginTop: 16,
                          }}
                        >
                          Reset
                        </Button>
                      </Space>
                    </Form.Item>
                  </center>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
};

export default ImageSelect;
